var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuccess = function SvgIconSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72217 10.1382L8.24069 12.4993L13.2777 7.7771",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.1382,
    r: 8.5,
    stroke: "white",
    strokeWidth: 1.5
  })));
};
export default SvgIconSuccess;